import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  getLimitsOperationsDataService,
  getLimitsUsersDataService,
} from '../services/limits.service';
import { TGetLimitsOperationsDataResponse, TGetLimitsUsersDataResponse } from '../types/limits.types';

export const limitsQueryKeys = createQueryKeys(EQueryKeys.LimitsQueryKeys, {
  getLimitsUsersData: (counterpartyGUID: string) => ({
    queryKey: ['limits-user-data', counterpartyGUID],
    queryFn: (): Promise<TGetLimitsUsersDataResponse> => getLimitsUsersDataService(counterpartyGUID),
  }),
  getLimitsOperationsData: (counterpartyGUID: string) => ({
    queryKey: ['limits-operations-data', counterpartyGUID],
    queryFn: (): Promise<TGetLimitsOperationsDataResponse> => getLimitsOperationsDataService(counterpartyGUID),
  }),
});
